/* unplugin-vue-components disabled */import script from "./InvoiceDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDetailDialog.vue?vue&type=style&index=0&id=afaa2e88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afaa2e88"]])

export default __exports__